module.exports = __webpack_public_path__ + "img/mapimg.d5bbd6a1.png";